import { render, staticRenderFns } from "./creatify-variants.vue?vue&type=template&id=4108dbc2&"
import script from "./creatify-variants.vue?vue&type=script&lang=js&"
export * from "./creatify-variants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports